import { gql } from '@apollo/client'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useDynamicServiceOrderState = () => React.useContext(Context)
export const useDynamicServiceOrder = () => useDynamicServiceOrderState()?.dynamicServiceOrder

const QUERY = gql`
  query DynamicServiceOrder($shareCode: String) {
    dynamicServiceOrder(shareCode: $shareCode) {
      id
      configuration
    }
  }
`

const DynamicServiceOrderLoader = ({ children, shareCode }) => {
  const { data, ...state } = useQuery(QUERY, {
    variables: { shareCode },
    client: serviceOrdersClient,
    fetchPolicy: 'cache-first'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default DynamicServiceOrderLoader
